import React, { memo } from 'react';
import { OrganismHeatingFormProps } from '../../../model/global';

// use welcome screen in data
type Props = OrganismHeatingFormProps['endScreen'];

const CompleteScreen: React.FC<Props> = props => {

	const { headline, text, button } = props

	React.useEffect(() => {
		const elem = document.getElementById('form-top')
		if (elem) setTimeout(() => elem.scrollIntoView({ behavior: 'smooth', block: 'start' }), 400)
	}, [])
// removed logo because of pro-klima
	return (
		<div className={'complete-screen'} id={'form-top'} >
			<div className={'complete-screen-wrapper-container'}>
				<h3 className={'complete-title'}>{headline?.text || ''}</h3>
				<p className={'complete-text'}>{text}</p>
				{
					button &&
					button?.href &&
					button?.href !== undefined &&
					button?.href !== '' &&
					button?.text &&
					(<a
						className={'complete-button'}
						href={button?.href}
						title={button?.title || ''}
						target={button?.target || '_self'}
					>
						{button?.text}
					</a>)
				}
			</div>
		</div>
	)
}

export default memo(CompleteScreen);
